import { Collapse, Divider, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import API from 'API';
import TermHandleComponent from '../UniversityTerms/TermHandle';
import FullMask from 'components/layout/FullMask';
import ScoreHandle from './ScoreHandle';
import CourseTermInfo from './CourseTermInfo';
import StudentHandle from './StudentHandle';

const NOW = dayjs();

export default function TermHandle({ course }) {
    const [pageMask, setPageMask] = useState(false);
    const [selectedTerm, setSelecterdTerm] = useState(null);
    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function getData() {
            try {
                const response = await API.get("/terms/", {
                    params: {
                        page_size: 1000
                    }
                });
                var check = false;
                for (const r of response.data.results) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                    if (!check) {
                        if (r.start_time.isBefore(NOW) && r.end_time.isAfter(NOW)) {
                            check = true;
                            setSelecterdTerm(r);
                        }
                    }
                }
                if (!check) {
                    setSelecterdTerm(response.data.results[0] || null);
                }
                setTerms(response.data.results);
                setLoading(false);
            } catch (e) {
                console.log(e);
            } finally {

            }
        }
        getData();
    }, [])
    return loading ? <Skeleton active /> : <div style={{ position: "relative" }}>
        {pageMask && <FullMask page />}
        <TermHandleComponent terms={terms} setTerms={setTerms} selectedTerm={selectedTerm}
            setSelecterdTerm={setSelecterdTerm} edit={false} />
        <CourseTermInfo course={course} selectedTerm={selectedTerm} />
        <Divider />
        <Collapse 
            items={[
                {
                    key: 1,
                    label: "Quản lý điểm",
                    children: <ScoreHandle course={course} selectedTerm={selectedTerm} setPageMask={setPageMask} />
                },
                {
                    key: 2,
                    label: "Quản lý sinh viên",
                    children: <StudentHandle course={course} selectedTerm={selectedTerm} setPageMask={setPageMask} />
                },
            ]}
        />
    </div>
}
